import React from 'react';
import { ExpandableNode } from './node-renderer';
import { Renderer } from '../shapes';

export const HyperLinkNode = (node, args) => (
  <ExpandableNode node={node} {...args}>
    <a href={node.href}>
      { args.nodeChildRenderer(node) }
    </a>
  </ExpandableNode>
);

HyperLinkNode.propTypes = Renderer;
